import { setJsonQuery } from 'shared/actions/filterJsonQuery';
import { setQueryString } from 'shared/actions/queryString';
import { selectQueryString } from 'shared/selectors';
import { TReduxStore } from 'shared/types/redux';

export function handleSetJsonQuery(store: TReduxStore, data: { jsonQuery: object }) {
  const queryString = selectQueryString(store.getState());

  if (queryString && queryString.trim() !== '') {
    store.dispatch(setQueryString(''));
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('search:clearTips'));
    }
  }

  store.dispatch(setJsonQuery(data.jsonQuery));
}
